import {
    Row,
    Col,
    Typography,
    Table,
    Button,
    message,
    Descriptions,
  } from "antd";
  import { routes } from "common/routes";
  import { generateHeaders, getSlotName } from "common/utils";
  import { AppPageHeader } from "components/AppPageHeader";
  import { useAppDispatch } from "hooks/useAppDispatch";
  import { useAppSelector } from "hooks/useAppSelector";
  import { useDocumentTitle } from "hooks/usePageTitle";
  import { useEffect, useMemo } from "react";
  import { useNavigate } from "react-router-dom";
import { cancelProcessingPickerMapping, removeProcessingPickerMapping, savePickerMapping } from "store/ppd/ppdSlice";
  
  const MESSAGE_KEY = "SAVE_REQUISITION";
  
  export const SavePickerRequisitionPage = () => {
    useDocumentTitle("Save Requisition");
    const { processingPickerMapping, status, error } = useAppSelector(
      (state) => state.ppd
    );
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
  
    useEffect(() => {
      const { timeUploaded } = processingPickerMapping;
      if (timeUploaded) {
        const uploadedTime = new Date(timeUploaded).getTime();
        const currentTime = new Date().getTime();
        const minsPassed = (currentTime - uploadedTime) / 1000 / 60;
  
        if (minsPassed >= 15) {
          dispatch(removeProcessingPickerMapping());
        }
      }
  
      if (!Object.keys(processingPickerMapping).length) { 
        navigate(`/${routes.PPD.UPLOAD}`);
      }
    }, [dispatch, processingPickerMapping, navigate]);
  
    useEffect(() => {
      if (status === "loading") {
        message.loading({ content: "saving requisition", key: MESSAGE_KEY });
      } else if (status === "success") {
        message.success({
          content: "PPD Mapping saved!",
          duration: 5,
          key: MESSAGE_KEY,
        });
      } else if (status === "cancelling") {
        message.loading({ content: "cancelling requisition", key: MESSAGE_KEY });
      } else if (status === "error") {
        message.error({ content: error, key: MESSAGE_KEY });
      }
  
      return () => {
        message.destroy();
      };
    }, [status, error]);
  
    let content;
    const { headerMapping } = processingPickerMapping;
    const { Text } = Typography;
  
    const generateMemoizedHeaders = useMemo(
      () => generateHeaders(headerMapping),
      [headerMapping]
    );
  
    const onSavePpd = () => {
      dispatch(savePickerMapping());
    };
  
    const onCancelSave = () => {
      dispatch(cancelProcessingPickerMapping());
    };
  
    if ((processingPickerMapping.success) === 0) {
      content = <Text>Nothing to show here!</Text>;
    } else {
      const headers = generateMemoizedHeaders || {};
      const successRows = processingPickerMapping.successRows;
      const data = successRows?.map((row, i) => ({ ...row, key: `data-${i}` }));
      const columns = [
        ...Object.keys(headers).map(
          (key) =>
            ({
              key,
              title: headers[key],
              dataIndex: key,
            } as any)
        ),
      ];
      content = (
        <Table
          size="small"
          columns={columns}
          dataSource={data}
          scroll={{ y: 500, x: "100vh" }}
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={24}>
                  <Row>
                    <Col>
                      <Button
                        type="primary"
                        onClick={onSavePpd}
                        loading={status === "loading"}
                        disabled={status === "loading"}
                      >
                        Save PPD
                      </Button>
                    </Col>
                    <Col style={{ justifyContent: "left", marginLeft: "20px" }}>
                      <Button
                        onClick={onCancelSave}
                        disabled={status === "loading"}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        ></Table>
      );
    }
  
    return (
      <>
        <Row>
          <Col>
            <AppPageHeader title="Save Picker Packer Mapping" />
          </Col>
        </Row>
        <Row>
          <Col xs={24}>{content}</Col>
        </Row>
      </>
    );
  };
  